import React from "react";
import { Typography, Breadcrumbs } from "@mui/material";
import { Link } from "react-router-dom";

const IconBreadcrumbs = ({ paths, separator }) => {
  const linkStyle = { display: "flex", color: "inherit" };
  const iconStyle = { marginRight: 4, width: 20, height: 20 };

  return (
    <Breadcrumbs separator={separator} aria-label="breadcrumb" style={{ marginBottom: "10px" }}>
      {paths.map((path, idx, arr) => {
        if (arr.length - 1 === idx) {
          return (
            <Typography color="textPrimary" style={linkStyle} key={path.id}>
              <path.icon style={iconStyle} />
              {path.name}
            </Typography>
          );
        }

        return (
          <Link to={path.to} style={linkStyle} key={path.id}>
            <path.icon style={iconStyle} />
            {path.name}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default IconBreadcrumbs;
